import React from 'react';
import { Col, Flex, Grid, Row, Spacer, Text, useField, useTheme } from 'vcc-ui';
import { Code } from './code';
import { Result } from './result';
import { Settings } from './settings';

export const LiveDemo = () => {
  const theme = useTheme();

  const demoTheme = useField({ name: 'demo-theme', value: 'light' });
  const demoRtl = useField({ name: 'demo-rtl', value: false });
  const demoVariant = useField({ name: 'demo-variant', value: 'default' });

  return (
    <Flex
      extend={{
        background: theme.color.background.secondary,
      }}
    >
      <Spacer size={10} />
      <Grid>
        <Row align="center">
          <Col>
            <Flex
              extend={{ [theme.breakpoints.fromM]: { textAlign: 'center' } }}
            >
              <Text variant="cook">UI Components that do the work for you</Text>
              <Spacer size={4} />
            </Flex>
          </Col>
        </Row>
        <Row align="center">
          <Col size={6}>
            <Flex
              extend={{ [theme.breakpoints.fromM]: { textAlign: 'center' } }}
            >
              <Text variant="hillary">
                We deliver the core building blocks, so you can focus on
                building your product. Switch between themes, styles and
                language direction with only minor changes to the underlying
                code.
              </Text>
            </Flex>
          </Col>
        </Row>
        <Spacer size={6} />
        <Row align="center">
          <Col size={{ [theme.breakpoints.fromL]: 3 }}>
            <Settings theme={demoTheme} rtl={demoRtl} variant={demoVariant} />
            <Spacer size={4} />
          </Col>
          <Col size={{ [theme.breakpoints.fromL]: 4 }}>
            <Result
              variant={demoVariant.value}
              theme={demoTheme.value}
              rtl={demoRtl.value}
            />
            <Spacer size={4} />
          </Col>
          <Col size={{ [theme.breakpoints.fromL]: 3 }}>
            <Code
              variant={demoVariant.value}
              theme={demoTheme.value}
              rtl={demoRtl.value}
            />
            <Spacer size={4} />
          </Col>
        </Row>
        <Spacer size={1} />
        <Row align="center">
          <Col size={6}>
            <Text extend={{ textAlign: 'center' }}>
              Go to the{' '}
              <Text
                href="https://vcc-ui-storybook.vercel.app"
                subStyle="inline-link"
              >
                Storybook
              </Text>{' '}
              or try the{' '}
              <Text
                href="https://vcc-ui-playroom.vercel.app/"
                subStyle="inline-link"
              >
                Playroom
              </Text>{' '}
              to see more UI components in action.
            </Text>
          </Col>
        </Row>
      </Grid>
      <Spacer size={10} />
    </Flex>
  );
};
